import * as LoginApi from '@/api/login'
import storage from '@/utils/storage'

export default {
  state: {
    token: storage.get('token') || '',
    chatToken: storage.get('chatToken') || ''
  },
  mutations: {
    SET_TOKEN: (state, value) => {
      storage.set('token', value)
      state.token = value
    },
    SET_CHAT_TOKEN: (state, value) => {
      storage.set('chatToken', value)
      state.chatToken = value
    }
  },
  actions: {
    Login ({ commit }, data) {
      return new Promise((resolve, reject) => {
        LoginApi.login({ form: data })
          .then(response => {
            if (response.status === 200) {
              commit('SET_TOKEN', response.data.token)
              commit('SET_CHAT_TOKEN', response.data.chat_token)
              resolve(response)
            } else {
              // reject(response)
            }
          })
          .catch((data) => {
            reject(data)
          })
      })
    },
    LogOut ({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        commit('SET_CHAT_TOKEN', '')
        resolve()
      })
    }
  },
  getters: {
    getToken (state) {
      return state.token
    }
  }
}
